import { getEnvironmentVariables } from '@training24/course/src/environmentVariables'

/**
 * Baut die vollständige Content-URL (Kursbilder, SCORM-Pakete) aus einem
 * S3-Key oder normalisiert eine bereits absolute /scorm-URL auf die aktuelle
 * Content-Base. Historische Datensätze enthalten absolute URLs mit einer
 * alten App-Domain (z. B. app.meda-… statt app2.meda-…) — die würden sonst
 * ins Leere zeigen. Externe URLs ohne /scorm-Pfad bleiben unverändert.
 */
export function toContentUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return ''
  const base = getEnvironmentVariables().contentBase.replace(/\/$/, '')
  if (!pathOrUrl.startsWith('http')) return `${base}/${pathOrUrl}`
  const match = pathOrUrl.match(/\/scorm\/(.+)$/)
  return match ? `${base}/${match[1]}` : pathOrUrl
}
